import { createSlice } from "@reduxjs/toolkit";
import { actionTypes } from "redux-query";
import { datapointsKey } from "store/middleware/analytics/analytics-grouping-middleware";
const initialState = { asyncQueryState: {}, connectionIds: [], entities: {} };
const updateAsyncQueries = (state, action) => {
    const listOfRequestsId = action.queryKey?.split("-").slice(1);
    if (listOfRequestsId.length) {
        listOfRequestsId.forEach((id) => {
            state.asyncQueryState[id] = { id, isFinished: false, isPending: true, requestId: action.body.id };
        });
    }
    return state;
};
const slice = createSlice({
    extraReducers: (builder) => {
        builder.addMatcher((action) => action.type === actionTypes.REQUEST_START &&
            action.body?.id && action.queryKey?.startsWith(datapointsKey) && action.body?.entityAlias, (state, action) => updateAsyncQueries(state, action));
    },
    initialState,
    name: "AsyncRequestsReducers",
    reducers: {
        setConnectionId: (state, action) => {
            if (action.payload.id && action.payload?.requests?.length) {
                for (const request of action.payload.requests) {
                    const item = { connectionId: action.payload.id, requestId: request };
                    const existing = state.connectionIds.find((c) => c.requestId === request);
                    if (existing) {
                        existing.connectionId = action.payload.id;
                    }
                    else {
                        state.connectionIds.push(item);
                    }
                }
            }
        },
        setEntity: (state, action) => {
            const { payload } = action;
            state.entities[payload.id] = { id: payload.requestId, responses: [payload.response] };
        },
        updateQueriesAsFinished: (state, action) => {
            const toUpdate = Object.values(state.asyncQueryState).filter((q) => q.requestId === action.payload)
                .map((x) => x.id);
            toUpdate.forEach((id) => {
                state.asyncQueryState[id].isPending = false;
                state.asyncQueryState[id].isFinished = true;
            });
        }
    }
});
export const asyncRequestsReducers = slice.reducer;
export const { setConnectionId, setEntity, updateQueriesAsFinished } = slice.actions;
